import React from 'react';
import { motion } from 'framer-motion';

const NeuralNetwork = () => {
  const nodes = [
    { x: 50, y: 50 }, { x: 150, y: 30 }, { x: 150, y: 70 },
    { x: 250, y: 20 }, { x: 250, y: 50 }, { x: 250, y: 80 },
    { x: 350, y: 35 }, { x: 350, y: 65 }, { x: 450, y: 50 },
  ];
  
  const connections = [
    [0, 1], [0, 2], [1, 3], [1, 4], [1, 5], [2, 3], [2, 4], [2, 5],
    [3, 6], [3, 7], [4, 6], [4, 7], [5, 6], [5, 7], [6, 8], [7, 8],
  ];

  return (
    <svg className="w-full h-24 opacity-30" viewBox="0 0 500 100">
      {connections.map(([from, to], i) => (
        <motion.line
          key={i}
          x1={nodes[from].x}
          y1={nodes[from].y}
          x2={nodes[to].x}
          y2={nodes[to].y}
          stroke="#FD802E"
          strokeWidth="1"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: [0.3, 0.8, 0.3] }}
          transition={{
            pathLength: { duration: 1, delay: i * 0.05 },
            opacity: { duration: 2, repeat: Infinity, delay: i * 0.1 },
          }}
        />
      ))}
      {nodes.map((node, i) => (
        <motion.circle
          key={i}
          cx={node.x}
          cy={node.y}
          r="6"
          fill="#233D4C"
          stroke="#FD802E"
          strokeWidth="2"
          initial={{ scale: 0 }}
          animate={{ scale: [1, 1.2, 1] }}
          transition={{
            scale: { duration: 2, repeat: Infinity, delay: i * 0.1 },
          }}
        />
      ))}
    </svg>
  );
};

export default NeuralNetwork;
